module.exports = __webpack_public_path__ + "img/AMERICAN EXPRESS.a1a2c823.png";